import React from "react";
import { MoveLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./login-signup.css";

const CandyWorld = () => {
  // Using useNavigate hook to handle navigation
  const navigate = useNavigate();

  // Function to handle back button click
  const handleBackClick = () => {
    navigate(-1); // Navigate to the previous page in history
  };

  return (
    <>
      <div className="login-panel candy-panel">
        <div className="back-button">
          <button onClick={handleBackClick}>
            <MoveLeft size={24} color="#fff" />
          </button>
        </div>
        <div className="candy-content">
          <h2 className="candy-title">Your Candy World</h2>
          <h3 className="candy-subtitle">Awaits</h3>
          <div className="curved-line"></div>
          <p className="candy-description">
            Manage your orders, track shipments, and discover exclusive deals. Enjoy new arrivals, special
            discounts, and a world of delightful treats just for you!
          </p>
        </div>
        <div className="candy-image">
          <img
            src="/1.png"
            alt="Candy character"
          />
        </div>
      </div>
    </>
  );
};

export default CandyWorld;